import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ConfirmDialogData {
  title: string;       // '' = no heading
  message: string;
  confirmText?: string;
  cancelText?: string;
  storageKey?: string;  // If provided, shows "Don't show again" checkbox
  /** If provided, the dialog asks for one line of text and closes with it
   *  (trimmed) instead of `true`. Cancel still closes with `false`. */
  input?: { value?: string; placeholder?: string };
  hideCancel?: boolean;  // A notice: one button
  /** An optional third button between Cancel and Confirm; the dialog closes with 'alt'. */
  altText?: string;
}

@Component({
    selector: 'app-confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss'],
    standalone: false
})
export class ConfirmDialogComponent {
  public dontShowAgain = false;
  public inputValue = '';

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {
    this.inputValue = data.input?.value ?? '';
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  onAlt(): void {
    this.dialogRef.close('alt');
  }

  onConfirm(): void {
    if (this.data.input) {
      this.dialogRef.close(this.inputValue.trim());
      return;
    }
    if (this.dontShowAgain && this.data.storageKey) {
      localStorage.setItem(this.data.storageKey, 'true');
    }
    this.dialogRef.close(true);
  }

  static shouldSkip(storageKey: string): boolean {
    return localStorage.getItem(storageKey) === 'true';
  }
}
